import React from 'react';

import styles from './case_card.module.css';

const CaseCard = ({ content, isVertical }) => {
  const { img, title, description } = content;

  return (
    <div className={isVertical ? styles.vContainer : styles.container}>
      <div className={styles.imgBox}>
        {img && (
          <img
            src={process.env.PUBLIC_URL + `/imgs/case/${img}.png`}
            alt={img}
          />
        )}
      </div>

      <div className={styles.textBox}>
        {isVertical ? (
          <img
            className={styles.quoteIcon}
            src={process.env.PUBLIC_URL + `/imgs/case/quote.png`}
            alt=''
          />
        ) : null}

        <div className={styles.title}>{title}</div>
        <div className={styles.description}>{description}</div>
      </div>
    </div>
  );
};

export default CaseCard;
